import { Component, OnInit, Input } from '@angular/core';
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { Room } from '../model/room';
import { Router } from '@angular/router';
import { Search } from '../model/search';
import { MotorService } from '../services/motor.service';
import { Empresa } from '../model/empresa';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
  selector: 'app-room',
  templateUrl: './room.component.html',
  styleUrls: ['./room.component.css'],
  providers: [NgbCarouselConfig]
})
export class RoomComponent implements OnInit {

  private empresa: Empresa;

  //habilita as setas para passar as imagens
  private showNavigationArrows = true;

  //habilita as setas para passar as imagens
  private showNavigationIndicators = false;

  @Input() room: Room;
  @Input() search: Search;
  @Input() tarifaPernoite: number;

  constructor(
    private readonly router: Router,
    private readonly carouselConfig: NgbCarouselConfig,
    private readonly motorService: MotorService,
    private spinnerService: NgxSpinnerService
  ) {
    this.motorService.empresaObservable.subscribe(empresa => this.empresa = empresa);
    carouselConfig.showNavigationArrows = this.showNavigationArrows;
    carouselConfig.showNavigationIndicators = this.showNavigationIndicators;
  }

  ngOnInit() {

  }

  buttonReservaOnClick() {
    const dados = {
      room:   this.room,
      search: this.search,
      tarifaPernoite: this.totalTarifaNoites(),
    };
    this.router.navigate(["company", this.empresa.token_motor, 'payment'], {state: {
      spiner: this.spinner(),
      dados: dados
    }});
  }

  //retorna o total da tarifa por noite
  totalTarifaNoites() {
    let totalNoites = this.search.noites;
    let tarifaDiaria = this.room.tarifa.valor;
    let total = tarifaDiaria;
    return total;
  }

  spinner(): void {
    this.spinnerService.show();
    setTimeout(() =>{
      this.spinnerService.hide();
    }, 2000);
  }

}
